var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaBareMetalDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-bare-metal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1663 18.3307H5.83301C4.45217 18.3307 3.33301 17.2116 3.33301 15.8307V4.16406C3.33301 2.78323 4.45217 1.66406 5.83301 1.66406H14.1663C15.5472 1.66406 16.6663 2.78323 16.6663 4.16406V15.8307C16.6663 17.2116 15.5472 18.3307 14.1663 18.3307Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99967 16.6693C10.9201 16.6693 11.6663 15.9231 11.6663 15.0026C11.6663 14.0821 10.9201 13.3359 9.99967 13.3359C9.0792 13.3359 8.33301 14.0821 8.33301 15.0026C8.33301 15.9231 9.0792 16.6693 9.99967 16.6693Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.333 6.66406H6.66634C6.20634 6.66406 5.83301 6.29073 5.83301 5.83073V4.9974C5.83301 4.5374 6.20634 4.16406 6.66634 4.16406H13.333C13.793 4.16406 14.1663 4.5374 14.1663 4.9974V5.83073C14.1663 6.29073 13.793 6.66406 13.333 6.66406Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.333 10.8359H6.66634C6.20634 10.8359 5.83301 10.4626 5.83301 10.0026V9.16927C5.83301 8.70927 6.20634 8.33594 6.66634 8.33594H13.333C13.793 8.33594 14.1663 8.70927 14.1663 9.16927V10.0026C14.1663 10.4626 13.793 10.8359 13.333 10.8359Z",
    fill: "#BFDFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaBareMetalDefault);
export default __webpack_public_path__ + "static/media/figma-bare-metal-default.76a5341000269a002d0176601af9f7e3.svg";
export { ForwardRef as ReactComponent };